import { ImageLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useExportAsPng } from '@/hooks'
import { ExportItem } from '../ExportItem'

interface Props {
  exportable: boolean
}

export const ExportPng: React.FC<Props> = ({ exportable }) => {
  const onClick = useExportAsPng(true)

  return (
    <ExportItem
      label="PNG"
      exportable={exportable}
      icon={ImageLight}
      onClick={onClick}
    />
  )
}
